import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, timeout } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { AuthenticationService } from '@core/authentication/authentication.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthenticationService);
  const router = inject(Router);

  if (req.url.includes('/assets/')) {
    return next(req);
  }

  return auth.getAccessToken().pipe(
    switchMap((token) => {
      const authReq = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

      return next(authReq).pipe(
        timeout(120_000),
        catchError((error) => {
          if (error instanceof HttpErrorResponse) {
            if (error.status === 401) {
              router.navigateByUrl('/authentication/unauthorized');
            }
          }
          return throwError(() => error);
        }),
      );
    }),
  );
};
